import { Form, FormFieldType } from "@/forms/Form";

export class WorkOrderGeneralDataForm extends Form {
  public definition = {
    usedTime: { required: true, type: FormFieldType.Time },
    doneTasks: { required: true, type: FormFieldType.MultiSelect },
    usedMaterial: { required: false, type: FormFieldType.MultiSelect }
  };
}
